import { useMemo, useState } from "react";

/**
 * useSortableTable — Πρόσθετη λειτουργικότητα ταξινόμησης ανά στήλη.
 * @param {Array} rows - Αρχική λίστα
 * @param {string} defaultKey - Προεπιλεγμένη στήλη
 * @param {"asc"|"desc"} defaultDir
 * @param {Object} accessors - { columnKey: (row) => primitive }
 */
export function useSortableTable(rows, defaultKey = null, defaultDir = "asc", accessors = {}) {
    const [sortKey, setSortKey] = useState(defaultKey);
    const [sortDir, setSortDir] = useState(defaultDir);

    const toggle = (key) => {
        if (sortKey === key) {
            setSortDir((d) => (d === "asc" ? "desc" : "asc"));
        } else {
            setSortKey(key);
            setSortDir("asc");
        }
    };

    const sorted = useMemo(() => {
        if (!sortKey) return rows;
        const get = accessors[sortKey] || ((r) => r[sortKey]);
        const dir = sortDir === "asc" ? 1 : -1;
        const collator = new Intl.Collator("el", { numeric: true, sensitivity: "base" });
        const out = [...rows].sort((a, b) => {
            const va = get(a);
            const vb = get(b);
            // null/undefined go last
            if (va == null && vb == null) return 0;
            if (va == null) return 1;
            if (vb == null) return -1;
            if (typeof va === "number" && typeof vb === "number") {
                return (va - vb) * dir;
            }
            return collator.compare(String(va), String(vb)) * dir;
        });
        return out;
    }, [rows, sortKey, sortDir, accessors]);

    return { sorted, sortKey, sortDir, toggle };
}

/**
 * Ικονίδιο ταξινόμησης — μικρό triangle. Δείξτο στο header.
 */
export function SortIndicator({ active, direction }) {
    if (!active) {
        return (
            <span className="ml-1 inline-block opacity-30 text-[10px]">↕</span>
        );
    }
    return (
        <span className="ml-1 inline-block text-[11px]">
            {direction === "asc" ? "▲" : "▼"}
        </span>
    );
}
